/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { withTranslation } from 'react-i18next';
// formik
import { Formik } from 'formik';
// @material-ui icons
import Check from '@material-ui/icons/Check';
// @material-ui/core components
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
// global variables
import { userRanks } from 'config';
// core components
import Card from 'components/UI/Card/Card';
import GridItem from 'components/UI/Grid/GridItem';
import CardBody from 'components/UI/Card/CardBody';
import Snackbars from 'components/UI/Snackbar/Snackbar';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import adCreateStyles from 'assets/jss/AdsCreate';
import { CREDIT_BUNDLE } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import Loading from 'components/common/Loading';
import UserSelect from 'components/User/Select';
import InfoUser from 'components/common/InfoUser';
import AuthContext from 'helpers/authContext';
import { isUserPublic } from 'helpers/functions';

/**
 * Initial values to AdForm
 */
const initialValues = {
  agency: null,
  ad: '',
  owner: undefined,
  currency: 'USD',
  secondaryCurrency: null,
  fromUserAgency: false,
  fromAdUser: true,
  price: '200',
  basePrice: '200',
};

class CreateCreditBundleForm extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        ...initialValues,
      },
      showSelectOwner: false,
      showSelectAgency: false,
    };
    this.formikRef = null;
  }

  /**
   * @description
   * Handle redirect of cancel btn.
   */
  handleCancelBtn = () => {
    const history = this.context;
    history.push(CREDIT_BUNDLE.LIST);
  };

  /**
   * @description
   * Updating before send to parent.
   *
   * @param {*} values - New values to update fields.
   * @param {Object} user - User data.
   * @returns {*} Undefined - No returns.
   */
  handleSubmit = (values, user) => {
    const { onSave, adUser } = this.props;
    const {
      ad,
      owner,
      currency,
      secondaryCurrency,
      agency,
      basePrice,
    } = values;
    return onSave({
      ad,
      // eslint-disable-next-line no-nested-ternary
      user: adUser ? (isUserPublic(adUser) ? adUser.id : undefined) : owner.id,
      agency: agency ? agency.id : user.id,
      currency,
      secondaryCurrency,
      price: basePrice,
    });
  };

  /**
   * @description
   * Set server errors with setErrors function of Formik.
   *
   * @param {*} serverErrors - Api errors.
   */
  setServerErrors = serverErrors => {
    let all = null;
    if (this.formikRef && serverErrors.length) {
      const errors = {};

      serverErrors.forEach(item => {
        errors[item.field] = item.messages;
        if (item.field === '__all__') {
          all = item.messages;
        }
      });

      setTimeout(() => this.formikRef && this.formikRef.setErrors(errors), 0);
    }
    return all;
  };

  /**
   * @description
   * Show / Hide Agency (manager) field
   *
   * @param {Object} manager - Data of manager user.
   * @param {Object} touched - Formik touched object.
   * @param {Object} errors - Formik errors object.
   * @param {Function} handleChange - Passed from Formik.
   * @returns {*} - React node.
   */
  renderAgencyField = (manager, touched, errors, handleChange) => {
    const { classes, t } = this.props;
    const { showSelectAgency } = this.state;
    return (
      <div style={{ marginBottom: 32 }}>
        <SweetAlert
          title=""
          showConfirm={false}
          showCancel={false}
          onConfirm={() => {}}
          customClass={classes.adModalConfirmation}
          show={showSelectAgency}
          closeOnClickOutside
          onCancel={() =>
            this.setState({
              showSelectAgency: !showSelectAgency,
            })
          }
        >
          <UserSelect
            listAgencies
            selectUser={agency => {
              handleChange({
                target: {
                  name: 'agency',
                  value: agency,
                },
              });
              // reset user owner
              if (!manager || (manager && agency.id !== manager.id)) {
                handleChange({
                  target: {
                    name: 'owner',
                    value: null,
                  },
                });
              }

              this.setState({
                showSelectAgency: !showSelectAgency,
              });
            }}
          />
        </SweetAlert>
        <div className={classes.section}>
          <h6
            style={{
              color: touched.agency && errors.agency ? 'red' : 'black',
            }}
          >
            {t('promoted_ad.form.fields.agency')}
          </h6>
          <div className={classes.categorySection}>
            {manager && <InfoUser user={manager} />}
            <React.Fragment>
              <Button
                simple
                color="primary"
                onClick={() =>
                  this.setState({
                    showSelectAgency: true,
                  })
                }
              >
                {manager
                  ? t('ad.form.fields.change')
                  : t('ad.form.fields.select')}
              </Button>
              {manager && (
                <Button
                  simple
                  color="primary"
                  onClick={() => {
                    handleChange({
                      target: {
                        name: 'agency',
                        value: null,
                      },
                    });
                    handleChange({
                      target: {
                        name: 'owner',
                        value: null,
                      },
                    });
                  }}
                >
                  {t('promoted_ad.form.clean')}
                </Button>
              )}
            </React.Fragment>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      classes,
      closeNotification,
      errors: serverErrors,
      submitLoading,
      t,
      creditBundlePrices,
      onGetAd,
      onResetAd,
    } = this.props;
    const { showSelectOwner, fields } = this.state;
    const all = this.setServerErrors(serverErrors);

    return (
      <AuthContext.Consumer>
        {/* eslint-disable-next-line consistent-return */}
        {user => {
          const hasGeneral =
            user.allPermissions.filter(
              permission => permission.codename === 'add_creditbundle',
            ).length === 1;
          return (
            <React.Fragment>
              <Snackbars
                place="tc"
                message={all || ''}
                open={!!all}
                color="danger"
                closeNotification={closeNotification}
                close
              />
              <Formik
                ref={ref => {
                  this.formikRef = ref;
                }}
                initialValues={fields}
                onSubmit={values => this.handleSubmit(values, user)}
                render={({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleSubmit,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className={classes.pageContainer}>
                      <div
                        className={`${classes.row} ${classes.contentBtns}`}
                        style={{ justifyContent: 'space-between' }}
                      >
                        <h3>{t('credit_bundles.form.title')}</h3>
                      </div>
                      <Card>
                        <CardBody>
                          <Loading show={submitLoading} />
                          {(hasGeneral || user.rank === userRanks.ADMIN) &&
                            this.renderAgencyField(
                              values.agency,
                              touched,
                              errors,
                              arg => {
                                handleChange(arg);
                              },
                            )}
                          <div>
                            <p
                              style={{
                                marginBottom: '30px',
                                fontSize: '20px',
                                textAlign: 'center',
                              }}
                            >
                              {t('credit_bundles.form.message')}
                            </p>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                                pointerEvents:
                                  !values.agency &&
                                  (hasGeneral || user.rank === userRanks.ADMIN)
                                    ? 'none'
                                    : 'initial',
                                opacity:
                                  !values.agency &&
                                  (hasGeneral || user.rank === userRanks.ADMIN)
                                    ? 0.5
                                    : 1,
                              }}
                            >
                              <div>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={values.fromAdUser}
                                      name="fromAdUser"
                                      checkedIcon={
                                        <Check
                                          className={classes.radioChecked}
                                        />
                                      }
                                      onChange={() => {
                                        handleChange({
                                          target: {
                                            name: 'fromAdUser',
                                            value: true,
                                          },
                                        });
                                        handleChange({
                                          target: {
                                            name: 'fromUserAgency',
                                            value: false,
                                          },
                                        });
                                      }}
                                      icon={
                                        <Check
                                          className={classes.radioUnchecked}
                                        />
                                      }
                                      className={classes.radio}
                                    />
                                  }
                                  label={t('credit_bundles.form.fromAdUser')}
                                />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    pointerEvents: values.fromAdUser
                                      ? 'inherit'
                                      : 'none',
                                    opacity: values.fromAdUser ? 1 : 0.5,
                                  }}
                                >
                                  <TextField
                                    label={t('promoted_ad.form.fields.id')}
                                    name="ad"
                                    error={touched.ad && !!errors.ad}
                                    helperText={touched.ad ? errors.ad : ''}
                                    InputProps={{
                                      value: values.ad,
                                      onChange: e => {
                                        onResetAd();
                                        handleChange(e);
                                      },
                                      onBlur: handleBlur,
                                      type: 'number',
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Radio
                                      checked={values.fromUserAgency}
                                      name="fromUserAgency"
                                      checkedIcon={
                                        <Check
                                          className={classes.radioChecked}
                                        />
                                      }
                                      onChange={() => {
                                        handleChange({
                                          target: {
                                            name: 'fromUserAgency',
                                            value: true,
                                          },
                                        });
                                        handleChange({
                                          target: {
                                            name: 'fromAdUser',
                                            value: false,
                                          },
                                        });
                                      }}
                                      icon={
                                        <Check
                                          className={classes.radioUnchecked}
                                        />
                                      }
                                      className={classes.radio}
                                    />
                                  }
                                  label={t(
                                    'credit_bundles.form.fromUserAgency',
                                  )}
                                />
                                <React.Fragment>
                                  <SweetAlert
                                    title=""
                                    showConfirm={false}
                                    showCancel={false}
                                    onConfirm={() => {}}
                                    customClass={classes.adModalConfirmation}
                                    show={showSelectOwner}
                                    closeOnClickOutside
                                    onCancel={() =>
                                      this.setState({
                                        showSelectOwner: !showSelectOwner,
                                      })
                                    }
                                  >
                                    {values.agency ? (
                                      <UserSelect
                                        agency={values.agency}
                                        selectUser={owner => {
                                          handleChange({
                                            target: {
                                              name: 'owner',
                                              value: owner,
                                            },
                                          });
                                          this.setState({
                                            showSelectOwner: !showSelectOwner,
                                          });
                                        }}
                                      />
                                    ) : (
                                      <UserSelect
                                        listUserAgencies
                                        selectUser={owner => {
                                          handleChange({
                                            target: {
                                              name: 'owner',
                                              value: owner,
                                            },
                                          });
                                          this.setState({
                                            showSelectOwner: !showSelectOwner,
                                          });
                                        }}
                                      />
                                    )}
                                  </SweetAlert>
                                  <div
                                    className={classes.section}
                                    style={{
                                      pointerEvents: values.fromUserAgency
                                        ? 'inherit'
                                        : 'none',
                                      opacity: values.fromUserAgency ? 1 : 0.5,
                                    }}
                                  >
                                    <h6
                                      style={{
                                        color:
                                          touched.owner && errors.owner
                                            ? 'red'
                                            : 'black',
                                      }}
                                    >
                                      {t('promoted_ad.form.fields.owner')}
                                    </h6>
                                    <div className={classes.row}>
                                      {values.owner && (
                                        <InfoUser user={values.owner} />
                                      )}
                                      <React.Fragment>
                                        <Button
                                          simple
                                          color="primary"
                                          id="selectOwner"
                                          onClick={() => {
                                            this.setState({
                                              showSelectOwner: true,
                                            });
                                          }}
                                        >
                                          {values.owner
                                            ? t('ad.form.fields.change')
                                            : t('ad.form.fields.select')}
                                        </Button>
                                        {values.owner && (
                                          <Button
                                            simple
                                            color="primary"
                                            onClick={() => {
                                              handleChange({
                                                target: {
                                                  name: 'user',
                                                  value: null,
                                                },
                                              });
                                            }}
                                          >
                                            {t('promoted_ad.form.clean')}
                                          </Button>
                                        )}
                                      </React.Fragment>
                                    </div>
                                  </div>
                                </React.Fragment>
                              </div>
                            </div>
                          </div>
                          <div
                            className={classes.section}
                            style={{ marginBottom: 32 }}
                          >
                            <div>
                              <div className={classes.section}>
                                <h6>{t('promoted_ad.form.fields.currency')}</h6>
                                {(() =>
                                  creditBundlePrices
                                    .map(({ currency }) => currency)
                                    .filter((v, i, a) => a.indexOf(v) === i)
                                    .map((currency, key) => (
                                      <Button
                                        key={`currency-${currency}`}
                                        simple={
                                          fields.secondaryCurrency
                                            ? fields.secondaryCurrency !==
                                              currency
                                            : fields.currency !== currency
                                        }
                                        round
                                        id={`currency-${key}`}
                                        color="primary"
                                        onClick={() => {
                                          handleChange({
                                            target: {
                                              name: 'secondaryCurrency',
                                              value:
                                                fields.currency !== currency
                                                  ? currency
                                                  : null,
                                            },
                                          });
                                          this.setState({
                                            fields: {
                                              ...fields,
                                              secondaryCurrency:
                                                fields.currency !== currency
                                                  ? currency
                                                  : null,
                                            },
                                          });
                                        }}
                                      >
                                        {currency}
                                      </Button>
                                    )))()}
                              </div>
                            </div>
                          </div>
                          <div
                            className={classes.section}
                            style={{ marginBottom: 32 }}
                          >
                            <div>
                              <div className={classes.section}>
                                <h6>
                                  {t('credit_bundles.form.fields.bundle_price')}
                                </h6>
                                {creditBundlePrices
                                  .filter(
                                    ({ currency }) =>
                                      currency ===
                                      (fields.secondaryCurrency ||
                                        fields.currency),
                                  )
                                  .map(({ price, basePrice }) => (
                                    <Button
                                      key={`bundle-price-${price}`}
                                      simple={values.price !== price}
                                      round
                                      id={`bundle-price-${price}`}
                                      color="primary"
                                      onClick={() => {
                                        handleChange({
                                          target: {
                                            name: 'price',
                                            value: price,
                                          },
                                        });
                                        handleChange({
                                          target: {
                                            name: 'basePrice',
                                            value: basePrice,
                                          },
                                        });
                                      }}
                                    >
                                      ${price}
                                    </Button>
                                  ))}
                              </div>
                            </div>
                          </div>
                          <div className={classes.section}>
                            <GridContainer direction="row-reverse">
                              <GridItem xs={12} sm={6}>
                                <div className={classes.contentBtns}>
                                  <Button
                                    id="save-packages"
                                    color="primary"
                                    onClick={() => {
                                      if (values.fromUserAgency) {
                                        this.formikRef.submitForm();
                                      }
                                      if (values.fromAdUser) {
                                        onGetAd(values.ad, adUser => {
                                          if (adUser) {
                                            this.formikRef.submitForm();
                                          } else {
                                            this.formikRef.setErrors({
                                              ad: t(
                                                'credit_bundles.form.invalid_ad',
                                              ),
                                            });
                                          }
                                        });
                                      }
                                    }}
                                  >
                                    {t('paidAd.form.button_create')}
                                  </Button>
                                </div>
                              </GridItem>
                              <GridItem xs={12} sm={6}>
                                <Button
                                  id="cancel-create"
                                  simple
                                  color="danger"
                                  onClick={this.handleCancelBtn}
                                >
                                  {t('common.cancel')}
                                </Button>
                              </GridItem>
                            </GridContainer>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </form>
                )}
              />
            </React.Fragment>
          );
        }}
      </AuthContext.Consumer>
    );
  }
}

/**
 * CreateCreaditBundleForm PropTypes
 * @param classes - styles received from withStyles
 * @param errors - Errors data list
 * @param submitLoading - To change to loading status
 * @param t - prop from HOC with string translations
 * @callback closeNotification - close notification
 * @callback onSave - callback called when user clicks save button
 */

CreateCreditBundleForm.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  errors: PropTypes.instanceOf(Array).isRequired,
  submitLoading: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  creditBundlePrices: PropTypes.instanceOf(Array).isRequired,
  adUser: PropTypes.instanceOf(Object),
  onGetAd: PropTypes.func.isRequired,
  onResetAd: PropTypes.func.isRequired,
};

CreateCreditBundleForm.defaultProps = {
  adUser: null,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const CreateCreditBundleFormWrapper = props => (
  <CreateCreditBundleForm {...props} />
);

export default withTranslation()(
  withStyles(adCreateStyles)(CreateCreditBundleFormWrapper),
);
